// components/Pagination.jsx
import React from "react";
import "../Home/Pagination.css"

const Pagination = ({ page, onPageChange, totalCount, limit }) => {
  const totalPages = Math.ceil(totalCount / limit);
  const pages = [];

  // Generate an array of page numbers (e.g., [1, 2, 3, 4])
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  return (
    <nav className="mt-4 d-flex justify-content-center">
      <ul className="pagination pagination-lg">

        {/* Prev Button */}
        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(page - 1)}
            disabled={page === 1}
          >
            &laquo;
          </button>
        </li>

        {/* Numbered Pages */}
        {pages.map((p) => (
          <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
            <button className="page-link" onClick={() => onPageChange(p)}>
              {p}
            </button>
          </li>
        ))}

        {/* Next Button */}
        <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(page + 1)}
            disabled={page === totalPages}
          >
            &raquo;
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
